const Api = {
    PUBLIC_API: "https://api.daapapp.com/api/v1/client/",
    PUBLIC_API_V2: "https://api.daapapp.com/api/v2/client/",
    AGENCY_API: "https://api.daapapp.com/api/v1/agency/",
    IMAGE_DOMAIN: "https://images.daapapp.com/"
};
export default Api;